import { CREATE_AND_OWN, EDIT, NONE, VIEW } from 'reporting-data/constants/userAccessLevel';
export const PermissionLevel = {
  [NONE]: NONE,
  [VIEW]: VIEW,
  [EDIT]: EDIT,
  [CREATE_AND_OWN]: CREATE_AND_OWN
};